export enum PaymentType {
  SUBSCRIPTION_INVOICE = 'SUBSCRIPTION_INVOICE',
  PURCHASE = 'PURCHASE',
  ENROLMENT = 'ENROLMENT',
  REFUND = 'REFUND',
  TRANSFER = 'TRANSFER'
}
